import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiCardInfoModule } from '@components/shared/ui-card-info/ui-card-info.module';
import { UiActionExpanderModule } from '@components/ui-action-expander';
import { UiFolderTreeBreadCrumbsModule } from '@components/ui-folder-tree-breadcrumbs/ui-folder-tree-breadcrumbs.module';
import { UiFolderTreeModule } from '@components/ui-folder-tree/ui-folder-tree.module';
import { DirectivesModule } from '@directives/directives.module';
import { SharedModule } from '@modules/shared.module';
import { AdSearchModule } from '@pages/users/components/ad-search/ad-search.module';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiScrollIntoViewModule } from '@uipath/angular/directives/ui-scroll-into-view';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { FoldersPageComponent } from './folders.page';
import { FolderUsersGridComponent } from './grids';
import {
    AssignUserModalComponent,
    UpsertFolderModalComponent,
} from './modals';

const MODALS = [
    AssignUserModalComponent,
    UpsertFolderModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        DirectivesModule,
        UiGridModule,
        UiSuggestModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiScrollIntoViewModule,
        UiSpinnerButtonModule,
        UiFolderTreeModule,
        UiFolderTreeBreadCrumbsModule,
        UiContentLoaderModule,
        UiActionExpanderModule,
        UiCardInfoModule,
        AdSearchModule,
    ],
    declarations: [
        FoldersPageComponent,
        FolderUsersGridComponent,
        ...MODALS,
    ],
    exports: [
        FoldersPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class FoldersModule { }
